import * as React from 'react';
import {observable} from 'mobx';
import {observer, Provider} from 'mobx-react';
import {pushStateLocationPlugin, UIRouter, UIView} from '@uirouter/react';
import {Context} from './lib/App/Context';
import {Store} from './lib/App/Store';
import {RouterConfig} from './lib/Routing/RouterConfig';
import {InitRouting} from './lib/Routing/Routes';

import './style.scss';

export interface AppConfig {
  apiUrl: string;
}

interface AppProps {
  config: AppConfig;
}

@observer
export class App extends React.Component<AppProps> {
  @observable private loading: boolean = true;
  private store?: Store;

  async componentDidMount() {
    const {config} = this.props;

    const context = new Context(config);
    await context.init();

    this.store = new Store(context);
    this.loading = false;
  }

  render() {
    if (this.loading) {
      return <div>Loading</div>;
    }

    if (!this.store) {
      return <div>App initialization error!</div>;
    }

    const {context} = this.store;

    return (
      <Provider store={this.store}>
        <UIRouter
          plugins={[pushStateLocationPlugin]}
          states={InitRouting({})}
          config={RouterConfig({
            persistRouter: context.setRouter,
          })}
        >
          <UIView />
        </UIRouter>
      </Provider>
    );
  }
}
